module.exports = "<div class=\"col-sm-12 text-left\">\n  <br/>\n\n   <p>To contact the Department through the Message Center, <a href=\"https://www.azre.gov/Contacts/EmailAdre.aspx\" target=\"_blank\">Click Here</a>.\n </p>\n  <button type=\"button\" (click)=\"goBackHome()\" class=\"button-style\">Return To Home</button> \n \n</div>\n<br/> \n"


//////////////////
// WEBPACK FOOTER
// ./src/app/shared/help/help.component.html
// module id = ./src/app/shared/help/help.component.html
// module chunks = main